import { ReactComponent as IconMenu } from '@/assets/svgs/menu-dark.svg'
import MenuDropDown from '@/components/MenuDropDown'
import useEclips from '@/hooks/use-eclips/index'
import useModal from '@/hooks/use-modal/index'
import { useParams } from '@/lib/router-dom/index'
import MultiClamp from 'react-multi-clamp'
import ConfirmDeleteModal from './confirm-delete-modal.jsx'

export default function ReceivingDataElementCard({
	eclipType,
	elementName,
	dataElementId,
	required,
	type,
	isEditable,
	isCustom,
	isDeclined,
	reload,
	message = 'You will be receiving this document',
	isCopy
}) {
	const { eclipId } = useParams()
	const { addRemoveDataElements } = useEclips()
	const { visible: confirmModalVisible, hide: hideConfirmModal, show: showConfirmModal } = useModal()

	if(isCopy) {
		return (<></>)
	}

	return (
		<div className={"eclip-data-elements__list-item" + (isDeclined ?" declined": "")}>
			<div className="eclip-data-elements__list-item-header">
				<div
					className="eclip-return-data-elements__list-icon"
					style={{
						backgroundImage: `url(/svgs/data-element.svg)`,
					}}
				></div>
				<div className="eclip-data-element__side-header">
					<div className="eclip-data-element__side-header">
						{eclipType === 'SEND' && isCustom && isEditable && (
							<MenuDropDown
								button={(props) => (
								<span
									className="eclip-landing_cursor-mode__pointer cursor-lg-area"
									{...props}
								>
									<IconMenu />
								</span>
								)}
								list={[
									{
										label: 'Remove Data Element',
										color: '#A72E12',
										onClick: async (e) => {
										e.stopPropagation()
										showConfirmModal()
										},
									}
								]}
							/>
						)}
					</div>
				</div>

			</div>
			{elementName && <div className="eclip-data-elements__list-item-title">
				<MultiClamp clamp={1}>{elementName}</MultiClamp>&nbsp;{required && <span>*</span>}
			</div>}
			<div className="eclip-data-elements__attachment">
				<span>{message}</span>
			</div>
			<ConfirmDeleteModal
				isVisible={confirmModalVisible}
				title="Remove Data Element"
				text={`Are you sure want to remove ${elementName} Data Element?`}
				cancel={hideConfirmModal}
				confirm={async () => {
					hideConfirmModal();
					await addRemoveDataElements(eclipId, 'REMOVE', [
						{ dataElementId, type },
					])
					reload()
				}}
			/>
		</div>
	)
}
